export const DROPDOWN_DIRECTION = 'top';

export const TEST_ID = 'mapControlPopover';
